<template>
  <v-progress-circular :class="classes" :indeterminate="indeterminate" :size="computedSize" :width="width" />
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'default',
      validator: (color) => ['info', 'success', 'warning', 'error', 'default'].includes(color),
    },

    indeterminate: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: 'medium',
      validator: (size) => ['x-small', 'small', 'medium', 'large', 'x-large'].includes(size),
    },

    width: {
      type: [String, Number],
      default: 2,
    },
  },

  computed: {
    classes() {
      let classes = 'ag-progress-circular';

      if (this.color) classes += ` ag-progress-circular--color-${this.color}`;

      return classes;
    },

    computedSize() {
      switch (this.size) {
        case 'x-small':
          return 8;
        case 'small':
          return 12;
        case 'medium':
          return 16;
        case 'large':
          return 20;
        case 'x-large':
          return 24;
        default:
          throw new Error(`Size '${this.size}' not defined`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-progress-circular {
  &.ag-progress-circular--default {
    color: $brand-color-primary-medium;
  }

  &.ag-progress-circular--info {
    color: $feedback-color-information-medium;
  }

  &.ag-progress-circular--success {
    color: $feedback-color-success-medium;
  }

  &.ag-progress-circular--warning {
    color: $feedback-color-attention-medium;
  }

  &.ag-progress-circular--error {
    color: $feedback-color-error-medium;
  }
}
</style>
